/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Canvas_ImageInputs */

const cs_builder_canvas_image = /** @type {(inputs: Builder_Canvas_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obrázek`)
};

const en_builder_canvas_image = /** @type {(inputs: Builder_Canvas_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image`)
};

/**
* | output |
* | --- |
* | "Image" |
*
* @param {Builder_Canvas_ImageInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_canvas_image = /** @type {((inputs?: Builder_Canvas_ImageInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Canvas_ImageInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_canvas_image(inputs)
	return cs_builder_canvas_image(inputs)
});